/**
 * Support FAQ + Form — accordion (one open at a time)
 */
if (!customElements.get('support-faq-form')) {
  customElements.define(
    'support-faq-form',
    class SupportFaqForm extends HTMLElement {
      constructor() {
        super();
        this.onToggle = this.onToggle.bind(this);
      }

      connectedCallback() {
        this.items = this.querySelectorAll('[data-faq-item]');

        for (const item of this.items) {
          const button = item.querySelector('[data-faq-trigger]');
          button?.addEventListener('click', this.onToggle);
        }
      }

      disconnectedCallback() {
        for (const item of this.items || []) {
          const button = item.querySelector('[data-faq-trigger]');
          button?.removeEventListener('click', this.onToggle);
        }
      }

      onToggle(event) {
        const button = event.currentTarget;
        const item = button.closest('[data-faq-item]');
        if (!item) return;

        const willOpen = !item.classList.contains('is-open');

        for (const other of this.items) {
          this.setOpen(other, false);
        }

        if (willOpen) {
          this.setOpen(item, true);
        }
      }

      setOpen(item, open) {
        const button = item.querySelector('[data-faq-trigger]');
        const panel = item.querySelector('[data-faq-panel]');

        item.classList.toggle('is-open', open);
        button?.setAttribute('aria-expanded', open ? 'true' : 'false');

        if (panel) {
          panel.hidden = !open;
        }
      }
    }
  );
}
